import {Rectangle, TooltipContentProps} from "recharts";
import {CursorProps} from "recharts/types/component/Cursor";

function TooltipContent(o: TooltipContentProps<number | string, string>) {
    const { payload, label } = o;
    return (
        <div
            className="customized-tooltip-content"
            style={{
                opacity: '0.95',
                backgroundColor: 'var(--bulma-background)',
                border: '1px solid var(--bulma-border)',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 0 10px rgba(0,0,0,0.2)',
            }}
        >
            {label && <h3 style={{
                padding: '0.5em',
                fontWeight: 'bold',
                boxShadow: 'var(--bulma-card-header-shadow)'
            }}>{`${label}`}</h3>}
            <ul style={{
                padding: '0.5em'
            }}>
                {payload.map((entry, index) => (
                    <li key={`item-${index}`} style={{ color: entry.color }}>
                        {`${entry.name}: ${entry.value}`}
                    </li>
                ))}
            </ul>
        </div>
    );
}

function TooltipCursor(props: Partial<CursorProps>) {
    const {cursor, tooltipEventType, coordinate, payload, index, zIndex, ...rectangleProps} = props
    return <Rectangle {...rectangleProps} fill="var(--bulma-text-70)" fillOpacity={0.3} stroke="none" />
}

export {
    TooltipCursor,
    TooltipContent
}
